//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "exception--404",
  methods: {
    // 跳转至首页
    redirectToHome() {
      /** 当前环境，CHANNAL_ID定义于main.js */
      const currentEnvironment = this.CHANNAL_ID;
      const homePath = currentEnvironment === "APP" ? "/appIndex" : "/newIndex";
      this.$router.push({
        path: homePath,
        query: {
          flag: "postdisable",
        },
      });
    },
  },
};
